import { OrderStepConfig } from '@models/order-step';
import { ElectronicsB2CDeviceComponent, ProductAdviceHandyComponent } from 'app/products/electronic/steps/';

export const electronicsB2CDevice: OrderStepConfig = {
    slug: 'versichertes-geraet',
    component: ElectronicsB2CDeviceComponent,
    title: 'Versichertes Gerät',
};

export const productAdviceHandy: OrderStepConfig = {
    slug: 'produktberatung',
    component: ProductAdviceHandyComponent,
    title: 'Produktberatung',
};
